import { z } from 'zod';
import { CoreCommunicationChannelTypeSchema } from '../inputTypeSchemas/CoreCommunicationChannelTypeSchema'

/////////////////////////////////////////
// NOTIFY MASS NOTIFICATION SCHEMA
/////////////////////////////////////////

export const NotifyMassNotificationSchema = z.object({
  channelType: CoreCommunicationChannelTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  startedAt: z.coerce.date().nullable(),
  completedAt: z.coerce.date().nullable(),
  total: z.number().int(),
  notifyContentId: z.number().int(),
  billingTransactionId: z.number().int().nullable(),
})

export type NotifyMassNotification = z.infer<typeof NotifyMassNotificationSchema>

export default NotifyMassNotificationSchema;
